:host {
  display: flex;
  flex-direction: column;

  .item-list-title {
    display: block;
    margin-bottom: 20px;
  }

  ul {
    list-style: none;
    padding-left: 0;
    width: 100%;

    li {
      position: relative;
      border-top: 1px solid #f0f0f0;
      padding: 10px 0;
      width: 100%;

      &:last-child {
        border-bottom: 1px solid #f0f0f0;
      }

      a {
        display: block;
        width: 100%;
        text-decoration: none;
        color: #0098ff;
        font-size: 15px;
        letter-spacing: 0;
        line-height: 24px;
        padding-right: 20px;
        box-sizing: border-box;
      }

      img {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 10px;
        height: 10px;
        object-fit: contain;
        filter: invert(54%) sepia(44%) saturate(7155%) hue-rotate(183deg) brightness(102%)
          contrast(109%);
        filter: var(--icon-white);
      }
    }
  }
}
